"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZXGNewsList = exports.ColumnNewsScroll = exports.LastNewsScroll = void 0;
var react_1 = __importDefault(require("react"));
var swr_1 = __importDefault(require("swr"));
var zixun_1 = require("../../../../modules/zixun");
var divscroll_1 = require("../../../divscroll");
require("./index.less");
var zxg_1 = require("../../../../modules/zxg");
/**
 * 最新消息滚动
 */
function LastNewsScroll() {
    var _a = (0, swr_1.default)("/new20zixun/", function () { return (0, zixun_1.getLastNews)(); }, {
        refreshInterval: 60 * 1000,
        dedupingInterval: 59 * 1000
    }), data = _a.data, error = _a.error;
    if (data) {
        return (react_1.default.createElement("div", { className: "lastnewsscroll" },
            react_1.default.createElement(divscroll_1.DivScroll, null, data.map(function (v, index) {
                var _a;
                return react_1.default.createElement(react_1.default.Fragment, { key: index },
                    react_1.default.createElement("span", { className: "time" }, ((_a = v === null || v === void 0 ? void 0 : v.Art_Showtime) === null || _a === void 0 ? void 0 : _a.length) >= 16 ? v.Art_Showtime.substring(10, 16) : ''),
                    react_1.default.createElement("a", { href: v.Art_UniqueUrl || v.Art_Url }, v.Art_Title));
            }))));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
}
exports.LastNewsScroll = LastNewsScroll;
/**
 * 频道资讯滚动
 * @param columns 频道id
 */
function ColumnNewsScroll(props) {
    var _a = (0, swr_1.default)("/news_column_scroll_/".concat(props.columns), function () { return (0, zixun_1.getNewsByColumn)(props.columns, 20); }, {
        refreshInterval: 60 * 1000,
        dedupingInterval: 59 * 1000
    }), data = _a.data, error = _a.error;
    if (data) {
        return (react_1.default.createElement("div", { className: "lastnewsscroll" },
            react_1.default.createElement(divscroll_1.DivScroll, null, data.map(function (v, index) {
                var _a;
                return react_1.default.createElement(react_1.default.Fragment, { key: index },
                    react_1.default.createElement("span", { className: "time" }, ((_a = v === null || v === void 0 ? void 0 : v.Art_Showtime) === null || _a === void 0 ? void 0 : _a.length) >= 16 ? v.Art_Showtime.substring(10, 16) : ''),
                    react_1.default.createElement("a", { href: v.Art_UniqueUrl || v.Art_Url }, v.Art_Title));
            }))));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
}
exports.ColumnNewsScroll = ColumnNewsScroll;
//自选股资讯表格/
function ZXGNewsList(props) {
    var _a = (0, swr_1.default)("zxglist", function () { return (0, zxg_1.getZXGDefaultGroupList)(); }, {
        refreshInterval: 30 * 60 * 1000,
        dedupingInterval: 29 * 60 * 1000
    }), data = _a.data, error = _a.error;
    return (react_1.default.createElement("div", { className: "zxgbox1table" },
        data && props.type == 'news' &&
            react_1.default.createElement(ZXGNewsListInner, { codelist: data.result.list.slice(0, 200).join(',') }),
        data && props.type == 'notice' &&
            react_1.default.createElement(ZXGNoticeListInner, { codelist: data.result.list.slice(0, 200).join(',') })));
}
exports.ZXGNewsList = ZXGNewsList;
/**
 * 自选股资讯
 * @param props
 * @returns
 */
function ZXGNewsListInner(props) {
    // const { data, error } = useSWR(`zxgnewslist`, ()=> getStocksNews(
    //   props.codelist,
    //   6
    // ),{
    //   refreshInterval: 10 * 60 * 1000,
    //   dedupingInterval: 9 * 60 * 1000
    // })
    var _a = (0, swr_1.default)("SelfSelectStockNews_CMS", function () { return (0, zixun_1.SelfSelectStockNews)(props.codelist, 6, "CMS"); }, {
        refreshInterval: 10 * 60 * 1000,
        dedupingInterval: 9 * 60 * 1000
    }), data = _a.data, error = _a.error;
    return (react_1.default.createElement("div", { className: "zxgnewslist" },
        react_1.default.createElement("ul", null, data && data.map(function (v, index) {
            var _a;
            return react_1.default.createElement("li", { key: index, className: "scf" },
                react_1.default.createElement("div", { className: "l" },
                    react_1.default.createElement("span", { className: "name" },
                        "[",
                        v.stockInfo.split("|")[1],
                        "]"),
                    react_1.default.createElement("a", { href: v.url, title: v.title }, v.title)),
                react_1.default.createElement("div", { className: "time" }, ((_a = v.date) === null || _a === void 0 ? void 0 : _a.length) >= 10 ? v.date.substring(5, 10) : ''));
        }))));
}
/**
 * 自选股公告
 * @param props
 * @returns
 */
function ZXGNoticeListInner(props) {
    // const { data, error } = useSWR(`zxgnoticelist`, ()=> getStocksNotice(
    //   props.codelist,
    //   6
    // ),{
    //   refreshInterval: 10 * 60 * 1000,
    //   dedupingInterval: 9 * 60 * 1000
    // })
    var _a = (0, swr_1.default)("SelfSelectStockNews_NOTICE", function () { return (0, zixun_1.SelfSelectStockNews)(props.codelist, 6, "NOTICE"); }, {
        refreshInterval: 10 * 60 * 1000,
        dedupingInterval: 9 * 60 * 1000
    }), data = _a.data, error = _a.error;
    return (react_1.default.createElement("div", { className: "zxgnewslist" },
        react_1.default.createElement("ul", null, data && data.map(function (v, index) {
            var _a;
            return react_1.default.createElement("li", { key: index, className: "scf" },
                react_1.default.createElement("div", { className: "l" },
                    react_1.default.createElement("a", { href: v.url, title: v.title }, v.title)),
                react_1.default.createElement("div", { className: "time" }, ((_a = v.date) === null || _a === void 0 ? void 0 : _a.length) >= 10 ? v.date.substring(5, 10) : ''));
        }))));
}
